import React from 'react';

import {DidomiSDK, IDidomiSDKProps} from "@didomi/react";
import {ARGS} from "../../bootstrap/args";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {AppTerms} from "../../app/app-terms";
import {DIDOMI_NOTICE} from "../../consts";
import {DidomiConfigModel} from "./config/didomi-config-model";
import {IDidomiObject} from "@didomi/react";

export class DidomiNoticeProps extends BaseProps {
  lang: String;
  isRtl: Boolean;
  i18n: AppTerms;
  onShow: Function;
  onHidden: Function;
  onReady: Function;
  onVendorsShow: Function;
  onPurposesShow: Function;
  popupButtonClick: Function;
  purposesButtonClick: Function;
  vendorsButtonClick: Function;
  initDidomi: Function;
}

const DidomiNotice = (props: DidomiNoticeProps) => {
  const config = new DidomiConfigModel(props.i18n, props.lang, props.isRtl);

  const didomiProps: IDidomiSDKProps = {
    config: config.getDidomiObject(),
    apiKey: ARGS.DIDOMI_API_KEY,
    noticeId: ARGS.DIDOMI_NOTICE_ID,
    iabVersion: DIDOMI_NOTICE.iabVersion,
    onReady: (didomi: IDidomiObject) => props.initDidomi && props.initDidomi(didomi),
    onNoticeShown: () => props.onShow && props.onShow(),
    onPreferencesClickViewVendors: () => props.onVendorsShow && props.onVendorsShow(),
    onNoticeClickAgree: () => props.popupButtonClick && props.popupButtonClick(DIDOMI_NOTICE.ANALYTICS.CLICK_TYPES.agree),
    onPreferencesClickAgreeToAll: () => props.purposesButtonClick && props.purposesButtonClick(DIDOMI_NOTICE.ANALYTICS.CLICK_TYPES.agreeAll),
    onPreferencesClickDisagreeToAll: () => props.purposesButtonClick && props.purposesButtonClick(DIDOMI_NOTICE.ANALYTICS.CLICK_TYPES.disagreeAll),
    onPreferencesClickSaveChoices: () => props.purposesButtonClick && props.purposesButtonClick(DIDOMI_NOTICE.ANALYTICS.CLICK_TYPES.save),
    onNoticeHidden: () => props.onHidden && props.onHidden(),
    onPreferencesClickVendorSaveChoices: () => {
      props.vendorsButtonClick && props.vendorsButtonClick(DIDOMI_NOTICE.ANALYTICS.CLICK_TYPES.save)
      props.onPurposesShow && props.onPurposesShow();
    },
    onNoticeClickMoreInfo: () => {
      props.popupButtonClick && props.popupButtonClick(DIDOMI_NOTICE.ANALYTICS.CLICK_TYPES.learnMore)
      props.onPurposesShow && props.onPurposesShow()
    },
  }

  return (
    <DidomiSDK {...didomiProps}/>
  )
};

export default DidomiNotice;
